import { AfterViewChecked, ChangeDetectorRef, Component, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef, MatRadioChange, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { CommonConstants } from 'src/app-core/constants/common-constants';
import { CustomPattern } from 'src/app-core/pattern/custom-pattern';
import { CommonService } from 'src/app-core/services/common.service';
import { CustomerService } from 'src/app/customer/customer.service';
import { AddressFieldComponent } from '../address-fields/address-fields.component';
import { IndustryLookupEnum } from '../app-common-enum';
import { CommonDataModel } from '../common-data-model';
import { AccountDialogComponent } from './account-dialog/account-dialog.component';

@Component({
    selector: 'app-lead-account-add-form',
    templateUrl: './lead-account-add-form.component.html',
    styleUrls: ['./lead-account-add-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class LeadAccountAddFormComponent implements OnInit, AfterViewChecked {
    @ViewChild('address', { static: true }) private address: AddressFieldComponent;

    pattern = new CustomPattern();
    commonDataModel = new CommonDataModel();
    leadAccountAddForm = this.commonDataModel.leadAccountAddFormModel;
    contactPhoneListModel = this.commonDataModel.contactPhoneListModel;
    industryLookupEnum: typeof IndustryLookupEnum = IndustryLookupEnum;
    accounts: Array<any> = [];
    addresses: Array<any> = [];
    leadSources: Array<any> = [];
    industries: Array<any> = [];
    contactData: Array<any>;
    isFormLoading = false;
    leadSourceItem = { leadSourceName: 'Select Lead Source', id: null };
    industryItem = { industryName: 'Select Industry', id: null };
    stateItem = { stateName: 'Select State', id: null };
    countryItem = { countryName: 'Select Country', id: null };
    leadFromData: any;
    rfqDetails: any;
    isQuickAccount = false;
    editQuickContactEditForm: any;
    addLeadAccountHeader = 'Add Lead Account';
    addAndContinueButton = 'Add & Continue';
    commonConstants: typeof CommonConstants = CommonConstants;

    constructor(
        private dialogRef: MatDialogRef<LeadAccountAddFormComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private customerService: CustomerService,
        private toastr: ToastrService,
        private commonService: CommonService,
        private dialog: MatDialog,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private router: Router) {
        if (data.isQuickAccount) {
            this.isQuickAccount = data.isQuickAccount;
            if (data.editQuickContactEditForm) {
                this.editQuickContactEditForm = data.editQuickContactEditForm;
                this.addLeadAccountHeader = 'Convert to Lead Account';
                this.addAndContinueButton = 'Update & Continue';
                this.editQuickContactEditForm.isConvertToLead = true;
            }
        }
    }

    ngOnInit() {
        this.leadFromData = this.data ? this.data : null;
        this.getIndustries();
        this.leadAccountAddForm.isIndividualAccount = '1';
        if (this.leadFromData && this.leadFromData.rfqDetails) {
            // this.isRfqPage = true;
            this.rfqDetails = this.leadFromData.rfqDetails;
            this.setDataForRFQ();
        }
        this.getLeadSources();
        if (this.isQuickAccount) {
            this.loadItems(this.editQuickContactEditForm);
            if(this.editQuickContactEditForm.isIndividualAccount) {
                this.leadAccountAddForm.isIndividualAccount = this.editQuickContactEditForm.isIndividualAccount;
            } else {
                this.leadAccountAddForm.isIndividualAccount = '1';
            }
        }
    }

    ngAfterViewChecked(): void {
        this.changeDetectorRef.detectChanges();
    }

    getRFQDetails(): void {
        const query = `?Id=${this.leadFromData.rfqDetails.rfqId}`;
        this.commonService.getRFQDetails(query, 0).subscribe(response => {
            if (response.isSuccess) {
                this.rfqDetails = response.data;
                this.setDataForRFQ();
            }
        });
    }

    setDataForRFQ() {
        if (this.rfqDetails && this.rfqDetails.companyName) {
            this.leadAccountAddForm.isIndividualAccount = '1';
        } else {
            this.leadAccountAddForm.isIndividualAccount = '2';
        }
        this.leadAccountAddForm.accountDetails.leadSourceId = this.rfqDetails.leadSourceId;
        this.leadAccountAddForm.contact.primaryPhone = this.rfqDetails.phone;
        this.leadAccountAddForm.contact.email = this.rfqDetails.email;
        this.leadAccountAddForm.contact.firstName = this.rfqDetails.firstName;
        this.leadAccountAddForm.contact.lastName = this.rfqDetails.lastName;
        this.leadAccountAddForm.address.zipCode = this.rfqDetails.originZip;
        this.leadAccountAddForm.accountName = this.rfqDetails.companyName;
        this.leadAccountAddForm.accountDetails.industryId = this.rfqDetails.industryId;
    }

    onAddPhone(): void {
        if (this.leadAccountAddForm.contact.contactNumberList.length < 3) {
            this.leadAccountAddForm.contact.contactNumberList.push(Object.assign({}, this.contactPhoneListModel));
        }
    }

    getLeadSources(): void {
        const query = this.rfqDetails && this.rfqDetails.rfqId ? '' : `IsRfQ=false`;
        this.commonService.getLeadSources(query).subscribe(response => {
            if (response.isSuccess) {
                this.leadSources = response.data;
            }
        });
    }

    getIndustries(): void {
        this.commonService.getIndustries().subscribe(response => {
            if (response.isSuccess) {
                this.industries = response.data;
            }
        });
    }

    onSubmit() {
        if (this.leadAccountAddForm.contact.primaryPhone) {
            let primaryContact = this.leadAccountAddForm.contact.primaryPhone.replace(/\D/g, '');
            if (primaryContact && primaryContact.length < 10 && !this.leadAccountAddForm.contact.isInternationalPhone) {
                this.toastr.warning(CommonConstants.appComponent.invalidPhoneNumber);
                return;
            }
        }
        this.isFormLoading = true;
        this.leadAccountAddForm.isRfqAccount = this.rfqDetails && this.rfqDetails.rfqId ? true : false;
        this.leadAccountAddForm.address = this.address.addressFields;
        this.leadAccountAddForm.accountDetails.accountStatusId = 1;
        this.leadAccountAddForm.quickAccount = this.isQuickAccount;
        this.leadAccountAddForm.isIndividualAccount = this.leadAccountAddForm.isIndividualAccount === '1' ? false : true;
        const filterData = this.leadAccountAddForm.contact.contactNumberList.filter((list, index, self) => {
            return self.map(mapObj => mapObj.phoneTypeId).indexOf(list.phoneTypeId) === index;
        });
        if (filterData.length === this.leadAccountAddForm.contact.contactNumberList.length) {
            if (this.editQuickContactEditForm && this.editQuickContactEditForm.isConvertToLead) {
                const quickContactEditForm = _.cloneDeep(this.leadAccountAddForm);
                quickContactEditForm.accountId = this.editQuickContactEditForm.accountId;
                quickContactEditForm.accountName = this.leadAccountAddForm.accountName;
                quickContactEditForm.address.addressId = this.editQuickContactEditForm.addressGuid;
                quickContactEditForm.contact.contactId = this.editQuickContactEditForm.contactGuidId;

                this.customerService.convertToFullAccount(quickContactEditForm).subscribe(response => {
                    if (response.isSuccess) {
                        this.toastr.success('Converted to full account successfully.');
                        this.onClose({ leadId: response.data });
                    } else {
                        this.toastr.error(response.errors);
                    }
                });
            } else {
                this.customerService.createAccount(this.leadAccountAddForm)
                    .subscribe(res => {
                        if (res.data) {
                            this.toastr.success('New lead account added successfully.');
                            this.onClose({ leadId: res.data });
                        }
                    });
            }
        } else {
            this.isFormLoading = false;
            this.toastr.warning('Duplication of phone types');
        }
    }

    onClose(confirmResult?: object): void {
        this.dialogRef.close(confirmResult);
    }

    loadItems(data: any): void {
        if (data.contactId) {
            this.leadAccountAddForm.contact.primaryPhone = data.phone;
            this.leadAccountAddForm.contact.email = data.email;
            this.leadAccountAddForm.contact.primaryExt = data.ext;
            this.leadAccountAddForm.contact.firstName = data.firstName;
            this.leadAccountAddForm.contact.lastName = data.lastName;
            this.leadAccountAddForm.address.zipCode = data.zipCode;
            this.leadAccountAddForm.address.addressLine1 = data.addressLine1;
            this.leadAccountAddForm.address.addressLine2 = data.addressLine2;
            this.leadAccountAddForm.address.addressTypeId = 1;
            this.leadAccountAddForm.address.city = data.city;
            this.leadAccountAddForm.accountName = data.accountName;
            this.leadAccountAddForm.notes = data.notes;
            this.leadAccountAddForm.accountDetails.leadSourceId = !data.leadSourceId || data.leadSourceId === 0 ? null : data.leadSourceId;
            this.leadAccountAddForm.accountDetails.industryId = !data.industryId || data.industryId === 0 ? null : data.industryId;
            this.leadAccountAddForm.contact.contactNumberList = data.alternateContacts ? data.alternateContacts : [];
            this.leadAccountAddForm.accountDetails.accountStatusId = '1';
            this.rfqDetails = {
                originZip: data.zipCode,
                city: data.city,
                countryId: data.countryId,
                province: data.province,
                addressLine1: data.addressLine1,
                addressLine2: data.addressLine2
            };
        }
    }

    onAccountTypeChange(event: MatRadioChange) {
        this.address.addressFields.addressIndicator = event.value;
    }

    onAddExistingAccount() {
        const searchText = '';
        this.commonService.getAccounts(searchText).subscribe(response => {
            this.accounts = response.data;
            if (this.accounts) {
                this.getExistingAccountPopup
                    (CommonConstants.appComponent.no, CommonConstants.appComponent.yes, false, true, this.accounts).then((result: any) => {
                        this.isFormLoading = false;
                        if (result.confirmResult && result.accountInfo.accountGuid) {
                            this.onCreateNewQuote(result.accountInfo.accountGuid, this.rfqDetails.rfqId);
                        }
                    });
            }
        });
    }

    getExistingAccountPopup(cancelLabel?: string, confirmLabel?: string, isHideCrossButton?: boolean, isAccountDropDownList?: boolean, accountList?: any) {
        return new Promise((resolve) => {
            this.dialog.open(AccountDialogComponent, {
                panelClass: 'existing_accounts_layout',
                hasBackdrop: false,
                data: {
                    cancelLabel: cancelLabel ? cancelLabel : 'No',
                    confirmLabel: confirmLabel ? confirmLabel : 'Yes',
                    isShowCrossButton: isHideCrossButton ? false : true,
                    isShowAccountDropDownList: isAccountDropDownList ? true : false,
                    dropDownData: accountList ? accountList : null
                },
            }).afterClosed()
                .subscribe((response: { confirmResult: boolean, accountInfo: any }) => {
                    resolve(response);
                });
        });
    }

    onCreateNewQuote(accountGuid: any, rfqId: any) {
        this.dialogRef.close();
        this.router.navigateByUrl(`app/quotes/quote-form?accountId=${accountGuid}&rfqId=${rfqId}`);
    }
}
